import { render, staticRenderFns } from "./addQuestionRules.vue?vue&type=template&id=674731e3&scoped=true&"
import script from "./addQuestionRules.vue?vue&type=script&lang=ts&"
export * from "./addQuestionRules.vue?vue&type=script&lang=ts&"
import style0 from "./addQuestionRules.vue?vue&type=style&index=0&id=674731e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674731e3",
  null
  
)

export default component.exports